import React from 'react';
import './Footer.css';

import { Heading, Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contacts, services } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaCar, FaFacebookF, FaInstagram, FaLinkedin, } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom'; 



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='footer-newsletter'>

        {/* Section heading */}
        <Heading title={'Newsletter Signup'} subTitle={'Exclusive Content'} linear sideHeading />

        {/* Newsletter component to subscribe */}
        <Newsletter />

      </div>

      <div className='box-container'>

        {/* Footer About Section */}
        <div className='footer-item'>

          <Logo /> {/* Logo component */}
          <p className='description'>Your adventure starts here. Rent the perfect car for every trip. Wide selection, competitive pricing, easy booking. Ensure a seamless online experience.</p> {/* Description for the about section */}

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Our Services Section */}
        <div className='footer-item'> 

          <h2>Our Services</h2>

          <div className='info links'> 
            {/* Mapping through the services and creating links to each service page */}
            {services.map(service => {
              /* Link to the individual service page */
              return <p key={service.id}><FaCar className='icon' /> 
                <Link
                  to={{ 
                    pathname: '/Services/' + service.title, // Dynamically constructing the link path
                  }}
                  location={{service}} // Passing service data to the route
                  state={service} // Passing service data in state
                >
                  {service.title}  {/* Display Service Title */}
                </Link>
              </p>
            })}
          </div>
        </div>

        {/* Useful Links Section */}
        <div className='footer-item'> 

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaCar className='icon' /><Link to='/About-us'>About Us</Link></p>
            <p><FaCar className='icon' /><Link to='/Car-Grid'>Cars</Link></p>
            <p><FaCar className='icon' /><Link to='/Portfolio'>Portfolio</Link></p>
            <p><FaCar className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><FaCar className='icon' /><Link to='/Shop-list'>Shop</Link></p>
            <p><FaCar className='icon' /><Link to='/Contact-us'>Contact Us</Link></p>
          </div>

        </div>

        {/* Contact Info Section */}
        <div className="footer-item">

          <h2>Contact Info</h2>
          <div className="info connect">
            {contacts
              .filter((contact) => contact.title !== "opening hours") // Exclude "opening hours"
              .map(({ id, icon, title, content }) => (
                <div className="connect-item" key={id}>
                  <div className="icon">{icon}</div>
                  <div className='text'>
                    <h3>{title}</h3>
                    {content.map((line, idx) => <p key={idx}>{line}</p>)}
                  </div>
                </div>
              ))}
          </div>

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; Designed By NorthStar_Themes | All Rights Reserved</p>

      </div>

    </footer>
  )
}

export default Footer;